<template>
  <v-app class="bgImage">
    <v-app-bar app color="primary">
      <v-toolbar-title class="text-uppercase secondary--text text--darken-3">
        <span class="font-weight-light">{{appNameFirst}} </span>
        <span class="font-weight-medium">{{appNameSecond}}</span>
      </v-toolbar-title>
    </v-app-bar>

    <v-content class="secondary--text text--darken-2">
      <v-container fill-height>
        <v-row class="fill-height">
          <v-col cols="12">
            <v-row fill-height justify="center">
              <v-col xs="12" sm="8" md="6" lg="4">
                <v-card class="mt-10">
                  <v-card-title
                    class="primary text-center pa-4 secondary--text text--darken-3"
                  >
                    <v-row justify="center">
                      <span
                        class="text-uppercase text-center font-weight-light"
                      >
                        <span class="font-weight-medium">
                          Set New Password
                        </span>
                      </span>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="mb-2 mt-4 text-center">
                    <h2 class="pb-3">{{$route.query.email}}</h2>
                    <p>
                      Set (or reset) the password to access your {{capitaliseFirstLetter(appNameFirst)}}.{{capitaliseFirstLetter(appNameSecond)}} account.
                    </p>
                  </v-card-text>
                  <v-card-actions>
                    <v-row align="center" justify="center">
                      <m-form v-slot="{model}"
                      :query="apiEndpoints.resetPassword"
                      :rules="validationRules"
                      :modelSrc="passwordResetData"
                      @success="onSuccess"
                      lazy-validation>
                        <!--v-row align="center" justify="center">
                          <m-textinput
                            :model="model"
                            name="token"
                            label="Device Token"
                            required
                          ></m-textinput>
                        </v-row-->
                        <v-row>
                            <m-password
                                :model="model"
                                name="password"
                                label="New Password"
                                required
                                ref="passwordInput"
                                autocomplete="new-password"
                            ></m-password>
                        </v-row>
                        <v-row>
                            <m-password
                                :model="model"
                                name="password_confirmation"
                                label="Repeat New Password"
                                required

                            ></m-password>
                        </v-row>
                        <v-row>
                            <m-submit label="Update Password" :model="model"> </m-submit>
                          <v-btn
                            text
                            color="primary"
                            class="mb-3"
                            @click="$router.push('/')"
                          >
                            Cancel
                          </v-btn>
                        </v-row>
                      </m-form>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import apiQueries from '../mixins/api-endpoints';

export default {
  mixins: [apiQueries],
  data() {
    return {
      appNameFirst: process.env.MIX_APPNAME_FIRST,
      appNameSecond: process.env.MIX_APPNAME_SECOND,
      allowUnauthenticated:true,
      showPassword: false,
      showPasswordConfirm: false,
      passwordResetData: {
        password: '',
        email: this.$route.query.email,
        token: this.$route.params.token,
      },
      passwordConfirm: '',
      validationRules:{
        password: (model) => [
            v => !!v || 'New password is required',
            v => (v && v.length >= 8) || 'New password must be at least 8 characters',
        ],
        password_confirmation: (model) => [
            v =>
                v == model.values.password ||
                'Password confirmation does not match new password'
            ,
        ],
      }
    };
  },
  methods: {
      onSuccess:function(body){
        console.log("BODY",body);
          this.storeToken(body.data);
          this.$router.push("/home");
      },
      capitaliseFirstLetter:function(str) {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      }
  },
  mounted() {

  },
};
</script>
